import { VenereBodyScanBox } from "../../../index"
import VenereBloodBox from "../../shared/components/VenereBloodBox"
import VenerePlatformLayout from "../../shared/pages/VenerePlatformLayout"
import VenereFoldersGrid from "../components/VenereFoldersGrid"
import { FOLDER_ITEMS } from "../config/folderItems"

export const VenereFolders: React.FC = () => {
  return (
    <VenerePlatformLayout>
      <div className="p-4 md:p-8 flex flex-col gap-6 items-center">
        <div className='flex flex-col items-center gap-4'>
          <div className='venere-text-heading text-center'>
            Qui trovi tutto ciò di cui hai bisogno
          </div>
          <div className='venere-text-subheading text-center'>
            Prescrizioni, referti, esami e tutto quello che ti serve.
          </div>
        </div>
        
        <VenereFoldersGrid items={FOLDER_ITEMS} />
        
        <VenereBloodBox/>
        <VenereBodyScanBox />
      </div>
    </VenerePlatformLayout>
  )
}
